import React from 'react';
import Header from '../homepage/components/Header';
import Footer from '../homepage/components/Footer';
import Seo from '../../components/Seo';

const factsSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'Facts for AI | Skyline VFX',
  description:
    'Machine-readable facts about Skyline VFX: what it is, who it is for, and what services are offered.',
};

export default function FactsForAiPage() {
  return (
    <>
      <Seo
        title="Facts for AI - Skyline VFX"
        description="Machine-readable facts about Skyline VFX: what it is, who it is for, and what services are offered."
        schema={factsSchema}
      />
      <div className="min-h-screen text-white">
        <Header />
        <main className="pt-32 pb-20 px-6 lg:px-8">
          <div className="max-w-4xl mx-auto space-y-10">
            <header className="space-y-3">
              <h1 className="text-4xl lg:text-5xl font-bold">Facts for AI</h1>
              <p className="text-gray-300">
                This page is a concise, crawlable reference intended to help search engines and AI systems describe Skyline
                VFX accurately.
              </p>
            </header>

            <section className="border border-white/10 bg-white/5 p-6 space-y-3">
              <h2 className="text-2xl font-semibold">Summary</h2>
              <p className="text-gray-300">
                Skyline VFX is the portfolio site of Lee Munday, a digital matte painter and concept artist specializing in
                photoreal environments for film and television VFX.
              </p>
            </section>

            <section className="border border-white/10 bg-white/5 p-6 space-y-3">
              <h2 className="text-2xl font-semibold">Services</h2>
              <ul className="list-disc pl-6 space-y-2 text-gray-300">
                <li>Digital matte painting (photoreal environments)</li>
                <li>Environment design and concept art</li>
                <li>Set extensions for VFX</li>
                <li>2.5D projection / camera mapping</li>
              </ul>
            </section>

            <section className="border border-white/10 bg-white/5 p-6 space-y-3">
              <h2 className="text-2xl font-semibold">Who it is for</h2>
              <ul className="list-disc pl-6 space-y-2 text-gray-300">
                <li>Film and television VFX productions</li>
                <li>Studios needing environment concept development</li>
                <li>Teams needing matte painting and set extension work</li>
              </ul>
            </section>

            <section className="border border-white/10 bg-white/5 p-6 space-y-3">
              <h2 className="text-2xl font-semibold">Contact</h2>
              <p className="text-gray-300">
                Email: <a className="underline" href="mailto:lmatthews@skylinevfx.com">lmatthews@skylinevfx.com</a>
              </p>
            </section>
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
}

